// extracted by mini-css-extract-plugin
export default {"card":"LoadingCard_card__vmeh2","icon":"LoadingCard_icon__mrVzf","message":"LoadingCard_message__xACLE","hint":"LoadingCard_hint__Szx-o"};